var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 mx-auto"},[_c('div',{staticClass:"text-center sticky-md",staticStyle:{"top":"92px"},attrs:{"id":"canvas-wrapper"}})])
}]

export { render, staticRenderFns }